// extracted by mini-css-extract-plugin
module.exports = {"PalletBoxes":"PalletBoxList_PalletBoxes__1giwF","PalletBoxTile":"PalletBoxList_PalletBoxTile__2MmRc"};